import {
  COMENZAR_USUARIO_CONTRASENA,
  USUARIO_CONTRASENA_EXITO,
  USUARIO_CONTRASENA_ERROR,
  RESET_USUARIO_CONTRASENA,
} from "../types";
import clienteAxios from "../../config/axios";
import { handlerError } from "../../utils/handlerError";

export function contrasenaUsuarioAction(credenciales) {
  return async (dispatch) => {
    const params = {
      contrasena: credenciales.contrasenaActual,
      contrasenaNueva: credenciales.contrasenaNueva,
    };
    dispatch(editarContrasena());
    await clienteAxios
      .patch(`/usuarios/cambiocontrasena?id=${credenciales.usuarioId}`, params)
      .then((respuesta) => {
        dispatch(editarContrasenaExito(respuesta.data));
      })
      .catch((err) => {
        if (err.response && err.response.status === 400) {
          err.response.statusText = err.response.data.msg;
        }
        dispatch(editarContrasenaError(handlerError(err)));
      });
  };
}

const editarContrasena = () => ({
  type: COMENZAR_USUARIO_CONTRASENA,
  payload: true,
});

const editarContrasenaExito = (result) => ({
  type: USUARIO_CONTRASENA_EXITO,
  payload: result,
});

const editarContrasenaError = (error) => ({
  type: USUARIO_CONTRASENA_ERROR,
  payload: error,
});

export function resetEditarContrasenaAction() {
  return async (dispatch) => {
    dispatch(resetEditarContrasena());
  };
}

const resetEditarContrasena = () => ({
  type: RESET_USUARIO_CONTRASENA,
  payload: true,
});
